







import { Component, Prop, Vue } from 'vue-property-decorator'
import { LineChart } from 'vue-chart-3'
import { Chart, ChartData, ChartOptions, LineController, LineElement, PointElement } from 'chart.js'
Chart.register(LineController, LineElement, PointElement)

export interface AchievedBarChartData {
    [month: string]: {
        achieved: number,
        target: number,
    }
}

@Component({
    components: {
        LineChart,
    },
})
export default class AchievedBarChart extends Vue {
    @Prop({ required: true, default: () => [] }) readonly data!: AchievedBarChartData
    @Prop() readonly formatter!: (value: number, precision?: number) => string

    get chartData(): ChartData {
        const labels = []
        const achievedData = []
        const targetData = []

        Object.keys(this.data).forEach(month => {
            labels.push(month)
            achievedData.push(this.data[month].achieved)
            targetData.push(this.data[month].target)
        })

        return {
            labels,
            datasets: [
                {
                    label: this.$t('reports.salesReport.achieved').toString(),
                    data: achievedData,
                    backgroundColor: 'rgb(0, 163, 137)',
                    order: 2,
                },
                {
                    type: 'line',
                    label: this.$t('reports.salesReport.target').toString(),
                    data: targetData,
                    backgroundColor: 'rgb(232, 234, 238)',
                    order: 1,
                },
            ],
        }
    }

    get chartOptions(): ChartOptions<'bar'> {
        return {
            responsive: true,
            maintainAspectRatio: true,
            aspectRatio: 2,

            plugins: {
                tooltip: {
                    callbacks: {
                        label: tooltipItem => {
                            return tooltipItem.dataset.label + ': ' + this.formatValue(tooltipItem.raw as number)
                        },
                    },
                },
            },
            scales: {
                y: {
                    beginAtZero: true,
                    ticks: {
                        precision: 0,
                        callback: tickValue => this.formatValue(tickValue as number, 0),
                    },
                },
            },
        }
    }

    formatValue(value: number, precision?: number): string {
        value = Number(value)

        return this.formatter ? this.formatter(value, precision) : value.toString()
    }
}
